import { createTheme, Theme } from '@mui/material';

import { globalTheme } from '../../../../../../../shared/theme/theme';
import { tableCellOverrides } from '../overrides/table-cell.overrides';
import { tableComponentOverrides } from '../overrides/table-component.overrides';
import { tableContainerOverrides } from '../overrides/table-container.overrides';
import { tablePaginationOverrides } from '../overrides/table-pagination.overrides';

const baseTableTheme: Theme = createTheme(globalTheme, {
  components: {
    MuiTableContainer: {
      styleOverrides: tableContainerOverrides,
    },
    MuiTable: {
      styleOverrides: tableComponentOverrides,
    },
    MuiTableCell: {
      styleOverrides: tableCellOverrides,
    },
    MuiTablePagination: {
      styleOverrides: tablePaginationOverrides,
    },
  },
});

export default baseTableTheme;
